import React from 'react';

const EllipsisText = ({ value, maxLength = 50 }) => {
    if (!value) return null;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = value;
    const plainText = tempDiv.textContent.trim();

    const isTooLong = plainText.length > maxLength;
    const displayedText = isTooLong ? plainText.slice(0, maxLength) + '...' : plainText;

    return <span title={plainText}>{displayedText}</span>;
};

export default EllipsisText;
